import { render, staticRenderFns } from "./scoringCanvas.vue?vue&type=template&id=40bd9485"
import script from "./scoringCanvas.vue?vue&type=script&lang=js"
export * from "./scoringCanvas.vue?vue&type=script&lang=js"
import style0 from "./scoringCanvas.vue?vue&type=style&index=0&id=40bd9485&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports